// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2IoOl","log":"ModalInventoryLogs_log__2Bb_H","date":"ModalInventoryLogs_date__K8PUP","userName":"ModalInventoryLogs_userName__3HfMz"};